import Icon from "../../../../../components/Icon";
import hint from "../../../../../components/TooltipButton/assets/hint.svg";
import IStudioError from "./StudioError.interface";
import styles from "./StudioError.module.css";

const StudioError = ({ header, content, onClose }: IStudioError) => {
  return (
    <div className={styles["studio-error__container"]}>
      <div className={styles["studio-error__header-container"]}>
        <img className={styles["studio-error__hint"]} src={hint} alt="Hint" />
        <div className={styles["studio-error__header-content"]}>{header}</div>
        {onClose && (
          <button
            className={styles["studio-error__close-button"]}
            onClick={onClose}
            aria-label="Закрыть"
          >
            <Icon name="close" />
          </button>
        )}
      </div>
      <div className={styles["studio-error__content-container"]}>{content}</div>
    </div>
  );
};

export default StudioError;